import React from 'react';
//import ReactDOM from 'react-dom'
import ModalVideo from 'react-modal-video'
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
} from '@fortawesome/free-solid-svg-icons';
import {faPlay} from "@fortawesome/free-solid-svg-icons";
import { Container, Row, Col } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

class IntroVideoPart extends React.Component {

  constructor () {
    super()
    this.state = {
      isOpen: false
    }
    this.openModal = this.openModal.bind(this)
  }

  openModal (e) {
    e.preventDefault();
    this.setState({isOpen: true})
  }

  render() { 
    const {t} = this.props
      return ( 
        <div className="intro-video-area bg_cover"
          style={{ backgroundImage: "url(assets/images/intro-video-bg.jpg)" }}
        >
          <div className="intro-overlay">
            <Container>
              <Row>
                <Col lg="6">
                  <div className="intro-video-content mt-30">
                    <span>{t('intro-video-part')}</span>
                    <h2 className="title">{t('intro-video-part.title')}</h2>
                    <p className="text-1">
                    {t('intro-video-part.title2')}
                    </p>
                    <p className="text-2">
                    {t('intro-video-part.desc')}
                    </p>
                    <Link 
                      className="main-btn wow fadeInLeft"
                      data-wow-duration="1s"
                      data-wow-delay=".1s"
                      to={"/"}
                    >
                      {t('learn-more')}
                    </Link>
                  </div>
                  {/* intro video content */}
                </Col>
                <Col lg="6">
                  <div className="intro-thumb mt-30">
                  <ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId='L61p2uyiMSo' onClose={() => this.setState({isOpen: false})} />
                    <img src="assets/images/intro-thumb.jpg" alt="" />
                    <Link  className="video-popup" to={"http://bit.ly/2VuPnrx"}  onClick={this.openModal}>
                      <FontAwesomeIcon icon={faPlay} size={`3x`} className={`pl-2 pt-3`}/>
                    </Link>
                  </div>
                  {/* intro thumb */}
                </Col>
              </Row>
              {/* row */}
            </Container>
            {/* container */}
          </div>
        </div>
        );
    }
}
 
export default withTranslation('translation')(IntroVideoPart);